import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/")({
  component: () => null,
  beforeLoad: () => {
    throw redirect({ to: "/dev/documents", replace: true });
  },
});
